var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.773.68c.082-.055.165-.055.274-.028l5.988 1.723L14.973.789c.41-.164.902.137.902.602v9.16c0 .273-.164.52-.437.601l-4.239 1.696c-.082.054-.164.054-.273.027l-5.988-1.723L1 12.738a.64.64 0 0 1-.875-.601v-9.16c0-.274.137-.52.41-.602zM1 11.809l3.5-1.395V1.72L1 3.113zm9.625-8.641-5.25-1.504v8.695l5.25 1.504zm.875 8.64 3.5-1.394V1.72l-3.5 1.394z"
  })));
};
export default SvgMap;